import { useState, useEffect } from 'react';

const HeroSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTextVisible, setIsTextVisible] = useState(false);

  const images = [
    'https://readdy.ai/api/search-image?query=Modern%20construction%20site%20with%20steel%20framework%20and%20concrete%20structures%20in%20progress%2C%20professional%20engineering%20work%2C%20clean%20industrial%20aesthetic%20with%20blue%20sky%20background%2C%20high%20quality%20architectural%20photography%20showing%20precision%20and%20expertise%20in%20building%20construction&width=1920&height=1080&seq=hero-construction-1&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Elegant%20residential%20building%20exterior%20with%20contemporary%20architecture%2C%20beautiful%20facade%20design%2C%20professional%20construction%20quality%2C%20warm%20natural%20lighting%2C%20showcasing%20excellence%20in%20modern%20home%20building%20and%20engineering%20craftsmanship&width=1920&height=1080&seq=hero-residential-2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Commercial%20building%20construction%20project%20with%20modern%20design%20elements%2C%20professional%20engineering%20site%2C%20clean%20minimalist%20background%2C%20blue%20hour%20lighting%2C%20demonstrating%20innovation%20and%20quality%20in%20construction%20industry&width=1920&height=1080&seq=hero-commercial-3&orientation=landscape',
    'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/a965864b13f1809b6f15fb62f02d00c4.jpeg',
    'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/5aab1144d3427eaf68769d9d7c7ba212.jpeg',
    'https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/0c40a2b60b05b0ba3846709483c1b8e2.jpeg'
  ];

  useEffect(() => {
    setIsTextVisible(true);
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section 
      id="accueil" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16 sm:pt-20"
    >
      {/* Images défilantes */}
      {images.map((image, index) => (
        <div
          key={index}
          className="absolute inset-0 transition-opacity duration-1000 ease-in-out"
          style={{
            opacity: currentImageIndex === index ? 1 : 0,
            backgroundImage: `url('${image}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        />
      ))}

      {/* Overlay sombre */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>

      {/* Contenu */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-12 sm:py-16">
        <div className="text-center text-white">
          <h2 
            className={`text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 leading-tight transition-all duration-1000 ${
              isTextVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-10'
            }`}
            style={{ transitionDelay: '200ms' }}
          >
            Global Grace Engineering<br />
            <span 
              className="text-blue-400 inline-block transition-all duration-1000"
              style={{ 
                transitionDelay: '400ms',
                transform: isTextVisible ? 'scale(1)' : 'scale(0.8)',
                opacity: isTextVisible ? 1 : 0
              }}
            >
              Ingénierie • Innovation • Excellence
            </span>
          </h2>
          <p 
            className={`text-base sm:text-lg md:text-xl lg:text-2xl mb-6 sm:mb-8 max-w-3xl mx-auto leading-relaxed px-4 transition-all duration-1000 ${
              isTextVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
            style={{ transitionDelay: '600ms' }}
          >
            Expert en construction résidentielle et commerciale à Lubumbashi et partout en RDC. 
            Nous transformons vos rêves en réalité avec expertise et passion.
          </p>
          <div 
            className={`flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4 transition-all duration-1000 ${
              isTextVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
            style={{ transitionDelay: '800ms' }}
          >
            <a 
              href="#contact" 
              className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-teal-700 hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap inline-flex items-center justify-center shadow-lg"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-phone-line"></i>
              </div>
              Devis Gratuit
            </a>
            <a 
              href="#projets" 
              className="bg-white text-teal-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-gray-100 hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap inline-flex items-center justify-center shadow-lg"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-eye-line"></i>
              </div>
              Voir nos Projets
            </a>
          </div>
        </div>
      </div>

      {/* Indicateurs de slides */}
      <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2 sm:gap-3 z-20">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentImageIndex(index)}
            className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all duration-300 cursor-pointer ${
              currentImageIndex === index 
                ? 'bg-teal-400 w-6 sm:w-8' 
                : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`Aller à l'image ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
